import React from "react";

import { epocToDate } from "utils";
import { CONTENT, VIRTUALIZATION_ERROR_MSGS } from "consts";
import { ReactComponent as LogsSafe } from "assets/images/app_svg/logs_safe.svg";
import { ReactComponent as LogsFail } from "assets/images/app_svg/logs_fail.svg";

function VirtualizationLogs(props) {
  function Title() {
    return (
      <div class="logs_item_title">
        {props.data.status === "Success" ? <LogsSafe /> : <LogsFail />}
        <p>{props.data.msg}</p>
      </div>
    );
  }

  return (
    <div
      class={[
        "logs_item ",
        props?.data?.status === "Success" ? "logs_safe" : "logs_failed"
      ].join(" ")}
    >
      {Title()}
      <div class="logs_item_details">
        <span>{epocToDate(props.timeStamp, "MMM d yyyy, hh:mm:ss")}</span>
        {props.data &&
        props.data.recoveryPoint &&
        props.data.recoveryPoint !== 0 &&
        props.data.recoveryPoint !== "" ? (
          <React.Fragment>
            <span> | </span>
            <span>
              Recovery version:{" "}
              {epocToDate(props.data.recoveryPoint, "MM-dd-yyyy, hh:mm:ss")}
            </span>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </div>
      {props.data.status === "Failure" && props.data.errorCode !== 212 && (
        <div class="logs_item_msg_list error_msg">
          <p>
            {" "}
            {VIRTUALIZATION_ERROR_MSGS[
              props.enums.props[props.data.errorCode]
                ? props.enums.props[props.data.errorCode].key
                : "default"
            ]
              ? VIRTUALIZATION_ERROR_MSGS[
                  props.enums.props[props.data.errorCode]
                    ? props.enums.props[props.data.errorCode].key
                    : "default"
                ]
              : VIRTUALIZATION_ERROR_MSGS["default"]}{" "}
          </p>
        </div>
      )}
    </div>
  );
}

export default VirtualizationLogs;
